import { ExpectedTaskAnswerMetadata, Task } from "@jelly/lesson";
import config from "appConfig";

const items = [
  {
    id: "5ede441d-326f-4dbe-b2b7-0d771cd55f71",
    options: { imageUrl: `${config.ASSETS_URL}/05/25/task/task-1-item-1.svg` },
  },
  {
    id: "6fa7217b-3f46-4dfa-9379-29eaa939dfbe",
    options: { imageUrl: `${config.ASSETS_URL}/05/25/task/task-1-item-2.svg` },
  },
  {
    id: "41ef8d78-39f1-431f-8e78-726958974e9b",
    options: { imageUrl: `${config.ASSETS_URL}/05/25/task/task-1-item-3.svg` },
  },
];

export const task: Task = {
  id: "c2df4b44-cdf1-4a0f-b811-a8c13c859896",
  solutionType: "order",
  type: "orderImages",
  options: {
    imageViewType: "contain",
    shuffle: true,
  },
  items,
};

export const expectedAnswerMetadata: ExpectedTaskAnswerMetadata = {
  solutionType: "order",
  data: [
    "5ede441d-326f-4dbe-b2b7-0d771cd55f71",
    "6fa7217b-3f46-4dfa-9379-29eaa939dfbe",
    "41ef8d78-39f1-431f-8e78-726958974e9b",
  ],
};
